export const listDictData = `/api/unoauth/system/listDictData`; // 数据字典数据
export const fileCloudToken = `/api/unoauth/minio/upload`; // 文件上传
export const filesCloudToken = `/api/unoauth/minio/batchUpload `; // 批量文件上传
export const fullTextSearch = `/api/unoauth/term/termQuery`; // 全文检索
export const buryPoint = `/api/unoauth/buryPoint/bury`; // 埋点
export const getUserById = `/api/unoauth/user/getUserInfoById`; // 获取用户信息
export const collectSomething = `/api/oauth/collect/insertProductmallWaresCollect`; // 收藏
export const deleteCollect = `/api/oauth/collect/deleteProductmallWaresCollect`; // 取消收藏

// 留言
export const leaveMessage = "/api/unoauth/onlineConsult/add";
export const leaveMessageList = "/api/unoauth/onlineConsult/list";
export const handleMessage = "/api/unoauth/onlineConsult/handle";
